import React from 'react'
import { connect } from 'react-redux';

function BandeauDroite({jeton}) {
  
    return (
        <div className="bandeaudroite">
            <a id="logo" href="/Portail_SPOT/" target="noreferrer">
                <img className="logo" src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Spot Agences" title="Spot Agences" style={{ height: 30 }} /></a>
            <a id="logo" href="https://www.ampmetropole.fr/" target="noreferrer">
                <img src={`${process.env.PUBLIC_URL}/images/metropole.png`} alt="logo métropole" style={{ height: 40, paddingRight: 5 }} />
            </a>
            <div style={{ color: "white" }} onClick={()=>document.location.reload(true)}>
                <img src={`${process.env.PUBLIC_URL}/images/deconnecter.png`} style={{ height: 25, width: 24.23, marginRight: 5 }} alt="Déconnecter" />
            </div>
        </div>
    )
}


function mapStateToProps(state) {
    return {
        jeton: state.jeton,
    }
}

export default connect(mapStateToProps, )(BandeauDroite);